import { Coverage } from "./coverages";
import { InsuranceBeneficiary } from "./insurance-beneficiary";
import { InsuranceCustomer } from "./insurance-customer";


export class Policy {
    // información de la poliza
    policyId?: number;
    policyNum?:string;
    country_name: string;
    emission_date?:Date;
    expiration_date?:string;
    product_name?:string;
    product_plan?:string;
    product_code?:string;
    name?:string;
    policyStatus?:string;
    coverage?:Coverage[];
    current_coverage?:Coverage;
    beneficiary?:InsuranceBeneficiary[];
    customer?:InsuranceCustomer[];
    extra_data?:any;
    CurrencyCode?:any;
    Currency?:any;
    ProductCoverageConfig?:{}
    references?: any[];
}